import React from 'react';
import { connect } from 'react-redux';
import {Grid, Row, Col, Image} from 'react-bootstrap';
import Layout from '../../components/layout/Layout';
import Card from '../../components/card/Card';
import { defaultRejectHandler } from '../../utils/utility';
import { translate } from 'react-i18next';

import { listProjectLocation } from '../../redux/projects/project_location_actions';

import '../../components/default.css';
import { compose, withProps } from 'recompose';
import Constants from '../../config/constants';
import { GoogleMap, InfoWindow, Marker, withGoogleMap, withScriptjs } from 'react-google-maps';
import ProjectCard from '../../components/projectcard/ProjectCard';

import markerGreen from '../../assets/images/marker_green.png';
import markerOrange from '../../assets/images/marker_red.png';
import markerGrey from '../../assets/images/marker_grey.png';
import markerBlue from '../../assets/images/marker_blue.png';

class Map extends React.Component {
  constructor(props) {
    super(props);

    this.state = { showInfoIndex: null };
  }

  toggleMarker(index) {
    this.setState({ showInfoIndex: index === this.state.showInfoIndex ? null : index });
  }

  navigateProjectDetail(project) {
  }

  renderIcon(energy_saving_percent) {
    if (energy_saving_percent >= 30) {
      return markerOrange;
    } else if (energy_saving_percent >= 50) {
      return markerOrange;
    } else if (energy_saving_percent >= 70) {
      return markerGreen;
    } else {
      return markerGrey;
    }
  }

  render() {
    let attr = {
      defaultZoom: 6,
      defaultCenter: {
        lat: Constants.MAP_CENTER_LAT,
        lng: Constants.MAP_CENTER_LNG,
      },
    };

    const { projects } = this.props;
    return (
      <GoogleMap {...attr}>
        {projects.map((project, index) => (
          <Marker
            key={`marker-${index}`}
            position={{ lat: parseFloat(project.latitude), lng: parseFloat(project.longitude) }}
            icon={this.renderIcon(project.energy_saving_percentage || 0)}
            onClick={() => this.toggleMarker(index)}
          >
            {this.state.showInfoIndex === index && <InfoWindow style={{ width: '300px' }} onCloseClick={() => this.toggleMarker()}>
              <ProjectCard
                className="project-map-marker"
                project={project}
                onClick={() => this.navigateProjectDetail(project)}
              />
            </InfoWindow>}
          </Marker>
        ))}
      </GoogleMap>
    );
  }
}

const ThaiMap = compose(
  withProps({
    googleMapURL: (() => {
      const url = `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places`;
      return url + (Constants.MAP_KEY ? `&key=${Constants.MAP_KEY}` : '');
    })(),
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `800px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap,
)(props => <Map {...props} />);

class InspectionDashboardPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      projectId: this.props.match.params.projectId,
      isShowEditModal: false,
      isShowDeleteModal: false,
      isShowUploadImageModal: false,
    };

    this.defaultStatus = 'unset';

    this.statusMapper = {
      unset: 'status-pending',
      failed: 'status-failed',
      passed: 'status-passed',
    };
  }

  componentWillReceiveProps(nextProps) {
  }

  componentDidMount() {
    this.props.listProjects();
  }

  renderActionMenu() {
    return [];
  }

  renderMap() {
    const { projects, history } = this.props;
    return <ThaiMap projects={projects} history={history}/>;
  }

  renderLegend() {
    const { t } = this.props;

    return (
      <ul className="marker-legend">
        <li><span><Image src={markerGrey} />{t('passed energy consumption')}</span></li>
        <li><span><Image src={markerOrange} />{t('passed all system 30%')}</span></li>
        <li><span><Image src={markerBlue} />{t('passed all system 50%')}</span></li>
        <li><span><Image src={markerGreen} />{t('passed all system 70%')}</span></li>
      </ul>
    );
  }

  render() {
    return (
      <Layout
        history={this.props.history}
        breadcrumbItems={[]}
        renderActionMenu={() => this.renderActionMenu()}
      >
        <Grid>
          <Row className="show-grid">
            <Col xs={12}>
              <Card padding={true}>
                {this.renderMap()}
                {this.renderLegend()}
              </Card>
            </Col>
          </Row>
        </Grid>
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  projects: state.projectLocation.orderedIds.map(id => state.projectLocation.objects[id]),
  isLoading: state.projectLocation.isLoading,
  errorMessage: state.project.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  listProjects: () => defaultRejectHandler(dispatch(listProjectLocation())),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(InspectionDashboardPage),
);



// WEBPACK FOOTER //
// ./src/pages/inspection_dashboard/InspectionDashboardPage.js